import React from "react";
import { Dots, Feeling, Photo } from "../../../svg";
import classes from "./CreatePostPopup.module.css";
import { useDispatch } from "react-redux";
import * as createPostSlice from "../../../app/slices/createPostSlice";

function AddToYourPost() {
  const dispatch = useDispatch();

  return (
    <div className={classes.add_to} data-testid="create-post-add-to-post">
      <div className={classes.addto_text}>Add to your post</div>
      <div className={classes.icons}>
        <button
          type="button"
          className={classes.addAction}
          aria-label="Add photos to update"
          data-testid="create-post-add-image"
          onClick={() => dispatch(createPostSlice.type("image"))}
        >
          <Photo color="#45bd62" />
        </button>
        <button
          type="button"
          className={classes.addAction}
          aria-label="Tag people"
          data-testid="create-post-tag-people"
        >
          <i className="tag_icon" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          className={classes.addAction}
          aria-label="Add a feeling"
          data-testid="create-post-add-feeling"
        >
          <Feeling color="#f7b928" />
        </button>
        <button
          type="button"
          className={classes.addAction}
          aria-label="Add a location"
          data-testid="create-post-add-location"
        >
          <i className="maps_icon" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          className={classes.addAction}
          aria-label="More update options"
          data-testid="create-post-more-options"
        >
          <Dots color="#65676b" />
        </button>
      </div>
    </div>
  );
}

export default AddToYourPost;
